// extracted by mini-css-extract-plugin
export default {"root":"IconTokens_root__jZwoX"};